module.exports = __webpack_public_path__ + "static/media/parts_07.680ea442.svg";